export const isChineseInString = (string) => {
  return /[\u4E00-\u9FA5]/g.test(string);
};
